<div class="top-bar-display" [class.top-bar-display--search-opened]="isSearchingSignal()">
  <div class="top-bar-display__row">
    @if (!isLoggedIn()) {
      <div class="top-bar-display__column" [style.margin-left]="'auto'">
        <a ftrButton color="primary" size="extra-small" [routerLink]="loginPath">Log In</a>
        <a ftrButton color="white" size="extra-small" [routerLink]="signupPath">Sign Up</a>
      </div>
    } @else {
      <div class="top-bar-display__column">
        <button
          class="top-bar-display__menu"
          (click)="toggleSideBar()"
          type="button"
          ftrButton
          title="Show Navigation Menu"
          aria-label="Show Navigation Menu"
          [autoWidth]="true"
          displayType="icon"
          [color]="buttonColor"
        >
          <ftr-icon icon="Menu" align="Middle"></ftr-icon>
        </button>
        @if (!isSearchingSignal()) {
          <ftr-breadcrumbs class="top-bar-display__breadcrumbs"></ftr-breadcrumbs>
        }
      </div>
      @if (!isSearchingSignal()) {
        <div class="top-bar-display__column">
          <ng-container *ngTemplateOutlet="searchBarTemplate"></ng-container>
          <ftr-account-dropdown [currentCourtSystemId]="currentCourtSystemId()"></ftr-account-dropdown>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="searchBarTemplate"></ng-container>
      }
    }
  </div>

  @if (showingBreadcrumbs) {
    <div class="top-bar-display__breadcrumbs--mobile">
      <ftr-breadcrumbs></ftr-breadcrumbs>
    </div>
  }
</div>

<ng-template #searchBarTemplate>
  @if (currentCourtSystemId()) {
    <ftr-top-bar-search
      [courtSystemId]="currentCourtSystemId()!"
      [isSearching]="isSearchingSignal()"
    ></ftr-top-bar-search>
  }
</ng-template>
